<template>
  <div class="section__header">
    <div class="container">
      <div class="header__wrapper flex">
        <a @click="prevPage" class="header__link header__link--styled ">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12.9053 15.2803C12.6124 15.5732 12.1376 15.5732 11.8447 15.2803L7.09467 10.5303C6.80178 10.2374 6.80178 9.76256 7.09467 9.46967L11.8447 4.71967C12.1376 4.42678 12.6124 4.42678 12.9053 4.71967C13.1982 5.01256 13.1982 5.48744 12.9053 5.78033L8.68566 10L12.9053 14.2197C13.1982 14.5126 13.1982 14.9874 12.9053 15.2803Z"
                  fill="black" />
          </svg>

        </a>
        <h2 class="header__title h2-title">{{ pagetitle }}</h2>
        <a :href="'tel:+'+phonenumber" target="_blank" class="header__phone"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                  xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_100_2049)">
            <path
                d="M14.8018 20.0002C8.02599 20.2293 -4.18066 8.12099 1.48683 1.55599L2.44517 0.722652C2.93027 0.253706 3.58051 -0.00536678 4.25519 0.00149539C4.92986 0.00835755 5.5747 0.280603 6.05016 0.759319C6.07586 0.785489 6.0998 0.813327 6.12183 0.842652L7.62183 2.79182C8.07768 3.27418 8.33096 3.91313 8.32941 4.57681C8.32786 5.2405 8.07159 5.87826 7.61349 6.35849L6.64849 7.57182C7.18276 8.86938 7.96801 10.0487 8.95918 11.042C9.95035 12.0353 11.1279 12.8231 12.4243 13.3602L13.6443 12.3893C14.1308 11.9425 14.767 11.6942 15.4275 11.6933C16.088 11.6923 16.7249 11.9389 17.2127 12.3843L19.1626 13.8843C19.1918 13.9063 19.2196 13.9299 19.246 13.9552C19.7269 14.4405 19.9967 15.0961 19.9967 15.7793C19.9967 16.4626 19.7269 17.1182 19.246 17.6035L18.4868 18.4785C18.0053 18.9653 17.4311 19.3507 16.7982 19.6121C16.1653 19.8734 15.4865 20.0054 14.8018 20.0002ZM4.226 1.66682C4.10624 1.66673 3.98764 1.69023 3.87697 1.73598C3.7663 1.78174 3.66573 1.84885 3.581 1.93349L2.62183 2.76682C-2.08316 8.42349 12.3143 22.0193 17.2668 17.3402L18.0268 16.4643C18.1172 16.3839 18.1907 16.2864 18.2432 16.1775C18.2957 16.0685 18.3261 15.9502 18.3327 15.8295C18.3393 15.7087 18.3219 15.5878 18.2816 15.4738C18.2412 15.3598 18.1787 15.2549 18.0976 15.1652L16.1585 13.676C16.1288 13.6541 16.1009 13.6299 16.0752 13.6035C15.9013 13.4378 15.6703 13.3454 15.4302 13.3454C15.19 13.3454 14.959 13.4378 14.7852 13.6035C14.763 13.6259 14.7397 13.647 14.7152 13.6668L13.0835 14.9668C12.9702 15.057 12.8354 15.1161 12.6924 15.1383C12.5493 15.1605 12.4029 15.1451 12.2677 15.0935C10.5878 14.4677 9.062 13.4881 7.79374 12.2211C6.52549 10.9542 5.54436 9.42941 4.91683 7.75015C4.86128 7.61296 4.84326 7.46345 4.86465 7.31699C4.88603 7.17053 4.94604 7.0324 5.0385 6.91682L6.3335 5.28682C6.35276 5.26213 6.37364 5.23874 6.396 5.21682C6.56622 5.04514 6.66173 4.81317 6.66173 4.5714C6.66173 4.32964 6.56622 4.09766 6.396 3.92599C6.37002 3.90007 6.34606 3.87221 6.32433 3.84265L4.8385 1.90599C4.67061 1.75429 4.45227 1.67052 4.226 1.67099V1.66682ZM18.8035 10.4802C22.9618 4.35932 15.6368 -2.95818 9.52266 1.19932C9.43046 1.26088 9.35146 1.34022 9.29031 1.43269C9.22915 1.52516 9.18706 1.62891 9.1665 1.73785C9.14595 1.84679 9.14733 1.95874 9.17058 2.06714C9.19383 2.17554 9.23848 2.27821 9.30191 2.36914C9.36534 2.46007 9.44627 2.53743 9.53997 2.59669C9.63367 2.65594 9.73825 2.69591 9.84759 2.71424C9.95693 2.73257 10.0688 2.7289 10.1767 2.70344C10.2846 2.67799 10.3864 2.63125 10.476 2.56599C15.0377 -0.566515 20.5676 4.96932 17.4368 9.52765C17.3701 9.61719 17.3221 9.71921 17.2956 9.82767C17.2691 9.93612 17.2647 10.0488 17.2826 10.159C17.3005 10.2692 17.3404 10.3747 17.3998 10.4691C17.4593 10.5636 17.5371 10.6452 17.6287 10.7091C17.7203 10.7729 17.8238 10.8177 17.933 10.8407C18.0422 10.8638 18.155 10.8647 18.2645 10.8433C18.3741 10.822 18.4783 10.7788 18.5709 10.7164C18.6635 10.6541 18.7426 10.5737 18.8035 10.4802ZM15.5885 8.92599C15.7447 8.76971 15.8325 8.55779 15.8325 8.33682C15.8325 8.11585 15.7447 7.90393 15.5885 7.74765L14.1668 6.32515V4.16682C14.1668 3.94581 14.079 3.73384 13.9227 3.57756C13.7665 3.42128 13.5545 3.33349 13.3335 3.33349C13.1125 3.33349 12.9005 3.42128 12.7442 3.57756C12.588 3.73384 12.5002 3.94581 12.5002 4.16682V6.66682C12.5002 6.88781 12.588 7.09974 12.7443 7.25599L14.411 8.92265C14.5673 9.07888 14.7792 9.16664 15.0002 9.16664C15.2211 9.16664 15.433 9.07888 15.5893 8.92265L15.5885 8.92599Z"
                fill="black" />
          </g>
          <defs>
            <clipPath id="clip0_100_2049">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
        </a>
      </div>

    </div>
  </div>
    <main class="main" :class="{'with_basket':basket_quantity>0}">
          <router-view />
    </main>
    <FlyBasket v-if="!hideBasket"></FlyBasket>
    <Footer></Footer>
</template>

<script>
import Footer from '../components/app/Footer'
import FlyBasket from '../components/app/FlyBasket'
export default {
  name: 'page-layout',
  data: () => ({

  }),
  computed: {
    phonenumber() {
      return this.$store.getters.phone.replace(/[^0-9]/g,'');;
    },
    pagetitle() {
      if (this.$route.name == 'page' && this.$store.getters.page[this.$route.params.id]) {
        return this.$store.getters.page[this.$route.params.id].title;
      }
      return this.$route.meta.title
    },
    login() {
      return this.$store.getters.login;
    },
    name() {
      if (typeof this.$store.getters.user == 'object')
        return this.$store.getters.user.UF_NAME;
    },
    isAuth() {
      return this.$store.getters.isAuth;
    },
    hideBasket() {
      if (this.$route.path == '/order' || this.$route.path == '/basket')
        return true;
      return false
    },
    basket_quantity() {
      return this.$store.getters.flyBasket.quantity;
    }
  },
  mounted() {
    if (this.$store.getters.isAuth === false) {
    //  this.$router.push('/login');
    }
  },
  methods: {
    prevPage() {
      if (this.$route.meta.prevpage)
        this.$router.push(this.$route.meta.prevpage)
      else
      if (this.$route.href == '/catalog/new')
        this.$router.push('/')
      else if (this.$route.name == 'section')
        this.$router.push('/catalog')
      else
        this.$router.go(-1)
    }
  },
  components: {
  Footer,
    FlyBasket
  }
}
</script>
